export default __webpack_public_path__ + "static/media/Blog3_3.943002ee.jpg";